import { render, staticRenderFns } from "./tabbar1.vue?vue&type=template&id=097e07f9&scoped=true"
import script from "./tabbar1.vue?vue&type=script&lang=js"
export * from "./tabbar1.vue?vue&type=script&lang=js"
import style0 from "./tabbar1.vue?vue&type=style&index=0&id=097e07f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097e07f9",
  null
  
)

export default component.exports